import TogglesLocal from './TogglesLocal'
import TogglesV2 from './TogglesManager'

const togglesDev = {
    useGetApiWhereVibia: 0, // Toggle enable use this url to get ip -> https://where.vibia.io if this toggle is disabled consume this -> https://api.ipify.org/?format=json
    showApplicationsNavigation: 1, // DV-1999 Change breadcrumbs for applications link navigation (same toggle on legacy)
    projectsFilterv2: 1, // DV-2404 Projects filters via v2
    masterControlsAPI2it: 1, //DV - 2526: Add master controls to vibiasync flow
    showSandboxView: 1, // No ticket -> just toggle if sandbox view should be visible
    projectRequestBudgetV2: 1, // DV-2591 - fix LW products prices sent to CRM.
    tubePdfFinishFix: 1, // DV-1156: Delete product finish in Tube pdf
    collectionsWithoutDesigner: 1,   // DV-2819 Disabled control with Designer for get collection service ...
    subFamilyCollectionsUpdate: 1, // DV-2819 Add description to subFamilyColecction 
    extendedUserLocation: 1, // DV-2849: Extended user location on sign up
    lightingEffectsFilter: 0, // DV-2799 Apply filters to the new model selector grouped by lighting effects (same toggle on legacy)
    metricalToImperial: 0, // DV-2880 Change meters to inches in usa catalogfinish the qualification flow
    listCompanyProjects: 1, // DV-2988 GET projects list with company projects too
    disableSendOrderToAS400ForQAUser: 1, //DV-3108 Don't send order to AS400 for QA user -> qa-prices-for-dist@vibia.com
    preventVibiaCompanyPrivilegesUpdate: 1, // DV-3112 Prevent vibia company that contains superuser from updating its priviles when synching companies
    showBOEprojectOrderSection: 1, // DV-3117 Show order section in backoffice eproject
    avoidLogoutImpersonating: 1, // DV-3117 Avoid logout using authImpersonate sending param keepLogged
    deleteSpaceTemperatureDescription: 1, // DV-2872 Incorrect temperature descritption in item product
    newLiteralsContact: 1, // DV-3291 show new literals for contact link in header
    uploadRegularProductsToCrm: 1, // DV-3304 Fix offers duplicated in crm when request a support.
    registerUserInCRM: 1, // DV-3181 User has not registered into CRM after sign in to the Web
    checkCmInSticksTransform: 1, // DV-3055 Check if sticks figure measures are in cm
    modalFeaturesEditDownload: 1, // DV-3371 Marketing tool to update the info of download items
    pricesDateFields: 1, // DV-2467: Modified price unroller method to parse price dates as dates instead of string
    newGetApplicationsEndpoint: 1, // THIS IS A LEGACY TOGGLE - DV-3445 added new endpoint to get applications

    //VibiaSync
    uploadsubFamilyCollectionsWithUpdatedApplicationsLocations: 1, // DV-3344 Upload subFamilyCollections mongo collection with the applicationLocations from their subfamily articles     
    replaceTempColourLedValue: 1, //DV-3383 fixed variation sync data in article for tempColourLed value
    plusminusSyncCheckStatus: 1, //DV-3389 check status isVirtual and isCatalog to sync Plusminus models 

    // PLUSMINUS toggles
    enableInsertFurniture: 1, // Enable insert furniture and other object in 3d
    confirmationInValidate: 1,
    debugBasicPlayerViewer: 0,

    createLights: 0,
    designPROTO: 0,
    menuInteracionRapidaVRS5: 0,
    bAutoPhysicsDisable: 0,
    splineSubirBajarCinta: 0,
    editLightButton: 0,
    enableTranversalGuideSegment: 1,
    newPlusminusPackagingRules: 1,
    onProcess: 1, //DV- 2021: Block interactions while segment is processing
    disableSuspensionForSegment_1_6: 1, // DV-1871 Fix suspensions number for segment 1.6
    moveRulerAndLabelFunctionality: 1, // DV-2327 Move the functionality of the ruler and labels out of the player.
    getAccesoriesByFamilyId: 1, // DV-2387 Fix belt accessories showing incorrect description.
    documentsValidationStatus: 1, // DV-2929: Show correct status validation for document generation.
    consumeAccesoriesJSONs: 1, // DV-2551: Consume accesories     
    sanitizeCommentsInProjectOrder: 1,  // DV-3088 No allow special character ;

    // Domain
    moveDomainMethodReturnsMovedElement: 1, // DV-3339: Modify domain move method to return moved element

    // Libs react-configurator-crea
    iFrameConfiguratorJwtControl: 1, // DV-1630, token control in iframe workspace

    // update crea xml in s3, clone product
    updateCreaXMLToS3: 1, // DV-647

    // rules
    rules: 1, // DV-1709: First iteration to rules; DONT REMOVE THIS TOGGLE

    //OptimizeFind
    regexFindUser: 1, //DV-2237: Enable find user without regex

    // CMS Sync 
    tagsParsingOnCMSSaveResource: 1, //DV-2219: Parse tags to ensure correct type before creating schemmas on CMS SaveResource
    addAccessoriesToModelData: 1, //DV-3361 add Accessories to model data when retrieve required model data

    // Compositor
    logCompositorRerenders: 0, // DEBUGG
    editProductDescription: 1, // DV-2943 Edit descriptions on product sheet
    addWindowTestingMethods: 1, // DV-3287: Add some testing methods to modify scene using window.testing object
    imperativelyUsePendantHeightIn3DV2: 1, // DV-3287: Make imperative the pendant height update in composing pendants V2
    colorPaletteToColorPicker: 1, // DV-3286: Remove colorPalette and colorPalettefullScreen creating only colorPicker component in common

    // Caches
    preconfigListWithCache: 1, //DV-2693: Add endpoint v2 with cache
    productsArticlesWithRedis: 1, //DV-2608 this toggle consume a endpoint with redis cache,
    productsArticlesWithRoleId: 1, // DV-2643 add role id to fetchCollections to send to V2,

    variationCatalog: 1, // DV-2118 asign catalogId in variations
    certificateCondition: 1, // DV-2439 conditions for display certificate in technicalInformationByModel

    dispatchQualificationRedirection: 1, // DV-1492 Post qualification options
    showIframeEprojectUnlogged: 1,  // DV-2536 show Iframe eproject is unlogged

    redisTTLDefault: 1, //DV-2838: Add default TTL to redis register

    lockLoginWeb: 1, //DV-3295 The web login in occasions locks

    // CRM
    crmSyncV2: 1, // DV-2368 new servirce for crmSync
    checkCrmBusinessActivities: 1, //DV-2825:: Check if petition of CRM is correct
    checkCrmProfessions: 1, // DV-2833: Check if CRM petition of professions is correct
    thirdPartyStatusAssignment: 1, // DV-2775 assignment thirdParty status in crm
    preventDuplicatedPendingProjects: 1, // DV-2951 Avoid duplicatedPendingProjects upload_pending_projects CRM syncro

    //CMS
    modifySpreadCMSFront: 1, //DV-3024 Fix error consume cache 

    //ERP
    replaceConflictCharacter: 1, //DV-3128 Replace ; character for : characater

    //Plasmic
    enableCDNPlasmicInProductSheet: 1, // DV-3300 Implement the Plasmic component injection solution through the CDN in the product sheets

    //BO
    editCollectionFeatures: 1, // DV-1884 Implement edit collections features tools in bo-eproducts

    // Debug
    logDomainConstructor: 0, // DEBUGG Toggle to debug domain constructor instantiation
}

const togglesNewPro = {    // New widget replaces old model grid
    useGetApiWhereVibia: 0, // Toggle enable use this url to get ip -> https://where.vibia.io if this toggle is disabled consume this -> https://api.ipify.org/?format=json
    showApplicationsNavigation: 1, // DV-1999 Change breadcrumbs for applications link navigation (same toggle on legacy)
    projectsFilterv2: 1, // DV-2404 Projects filters via v2  
    masterControlsAPI2it: 1, //DV - 2526: Add master controls to vibiasync flow
    showSandboxView: 0, // No ticket -> just toggle if sandbox view should be visible
    projectRequestBudgetV2: 1, // DV-2591 - fix LW products prices sent to CRM.
    tubePdfFinishFix: 1, // DV-1156: Delete product finish in Tube pdf
    collectionsWithoutDesigner: 1, // DV-2819 Disabled control with Designer for get collection service
    subFamilyCollectionsUpdate: 1, // DV-2819 Add description to subFamilyColecction 
    extendedUserLocation: 1, // DV-2849: Extended user location on sign up
    lightingEffectsFilter: 0, // DV-2799 Apply filters to the new model selector grouped by lighting effects (same toggle on legacy)
    metricalToImperial: 0, // DV-2880 Change meters to inches in usa catalog
    updateAuthCookiesOnQualify: 1, // DV-2472 update auth cookies when user finish the qualification flow
    listCompanyProjects: 1, // DV-2988 GET projects list with company projects too
    disableSendOrderToAS400ForQAUser: 1, //DV-3108 Don't send order to AS400 for QA user -> qa-prices-for-dist@vibia.com
    preventVibiaCompanyPrivilegesUpdate: 1, // DV-3112 Prevent vibia company that contains superuser from updating its priviles when synching companies
    showBOEprojectOrderSection: 0, // DV-3117 Show order section in backoffice eproject
    avoidLogoutImpersonating: 1, // DV-3117 Avoid logout using authImpersonate sending param keepLogged
    deleteSpaceTemperatureDescription: 1, // DV-2872 Incorrect temperature descritption in item product
    newLiteralsContact: 1, // DV-3291 show new literals for contact link in header
    consumeAccesoriesJSONs: 1, // DV-2551: Consume accesories     
    sanitizeCommentsInProjectOrder: 0, // DV-3088 No allow special character ;
    uploadRegularProductsToCrm: 1, // DV-3304 Fix offers duplicated in crm when request a support.
    registerUserInCRM: 1, // DV-3181 User has not registered into CRM after sign in to the Web
    checkCmInSticksTransform: 1, // DV-3055 Check if sticks figure measures are in cm
    modalFeaturesEditDownload: 1, // DV-3371 Marketing tool to update the info of download items
    pricesDateFields: 1, // DV-2467: Modified price unroller method to parse price dates as dates instead of string
    newGetApplicationsEndpoint: 1, // THIS IS A LEGACY TOGGLE - DV-3445 added new endpoint to get applications

    // Domain
    moveDomainMethodReturnsMovedElement: 0, // DV-3339: Modify domain move method to return moved element

    //VibiaSync
    uploadsubFamilyCollectionsWithUpdatedApplicationsLocations: 1, // DV-3344 Upload subFamilyCollections mongo collection with the applicationLocations from their subfamily articles     
    replaceTempColourLedValue: 1, //DV-3383 fixed variation sync data in article for tempColourLed value
    plusminusSyncCheckStatus: 1, //DV-3389 check status isVirtual and isCatalog to sync Plusminus models 

    // PLUSMINUS toggles
    enableInsertFurniture: 0, // Enable insesrt furniture and other object in 3d
    confirmationInValidate: 0,
    debugBasicPlayerViewer: 0,
    plusminusApplyDriverPowerMargin: 0, // DV-6338: Derate each Plusminus driver/installation-type by its own driver.driverSafetyMargin (%, maintained by business in ForceManager) when deciding compatibility. References without the field keep the current behaviour, so the rollout is gated by both this toggle and the data.
    createLights: 0,
    designPROTO: 0,
    menuInteracionRapidaVRS5: 0,
    bAutoPhysicsDisable: 0,
    splineSubirBajarCinta: 0,
    editLightButton: 0,
    enableTranversalGuideSegment: 1,
    newPlusminusPackagingRules: 1,
    onProcess: 0, //DV- 2021: Block interactions while segment is processing
    disableSuspensionForSegment_1_6: 1, // DV-1871 Fix suspensions number for segment 1.6
    moveRulerAndLabelFunctionality: 1, // DV-2327 Move the functionality of the ruler and labels out of the player.
    getAccesoriesByFamilyId: 1, // DV-2387 Fix belt accessories showing incorrect description.
    documentsValidationStatus: 1, // DV-2929: Show correct status validation for document generation.

    // Libs react-configurator-crea
    iFrameConfiguratorJwtControl: 1, // DV-1630, token control in iframe workspace

    // update crea xml in s3, clone product
    updateCreaXMLToS3: 1, // DV-647

    // rules
    rules: 1, // DV-1709: First iteration to rules; DONT REMOVE THIS TOGGLE

    //OptimizeFind
    regexFindUser: 1, //DV-2237: Enable find user without regex

    // CMS Sync 
    tagsParsingOnCMSSaveResource: 1, //DV-2219: Parse tags to ensure correct type before creating schemmas on CMS SaveResource
    addAccessoriesToModelData: 1, //DV-3361 add Accessories to model data when retrieve required model data

    // Compositor
    logCompositorRerenders: 0, // DEBUGG
    editProductDescription: 1, // DV-2943 Edit descriptions on product sheet
    addWindowTestingMethods: 0, // DV-3287: Add some testing methods to modify scene using window.testing object
    imperativelyUsePendantHeightIn3DV2: 0, // DV-3287: Make imperative the pendant height update in composing pendants V2
    colorPaletteToColorPicker: 0, // DV-3286: Remove colorPalette and colorPalettefullScreen creating only colorPicker component in common

    variationCatalog: 1, // DV-2118 asign catalogId in variations

    // Caches
    preconfigListWithCache: 1, //DV-2693: Add endpoint v2 with cache
    productsArticlesWithRedis: 1, //DV-2608 this toggle consume a endpoint with redis cache
    productsArticlesWithRoleId: 1, // DV-2643 add role id to fetchCollections to send to V2,

    certificateCondition: 1, // DV-2439 conditions for display certificate in technicalInformationByModel
    dispatchQualificationRedirection: 1, // DV-1492 Post qualification options
    showIframeEprojectUnlogged: 1,  // DV-2536 show Iframe eproject is unlogged

    redisTTLDefault: 1, //DV-2838: Add default TTL to redis register

    lockLoginWeb: 1, //DV-3295 The web login in occasions locks

    // CRM
    crmSyncV2: 1, // DV-2368 new servirce for crmSync
    checkCrmBusinessActivities: 1,//DV-2825:: Check if petition of CRM is correct
    checkCrmProfessions: 1, // DV-2833: Check if CRM petition of professions is correct
    thirdPartyStatusAssignment: 1, // DV-2775 assignement thirdParty status in crm
    preventDuplicatedPendingProjects: 1, // DV-2951 Avoid duplicatedPendingProjects upload_pending_projects CRM syncro

    //CMS
    modifySpreadCMSFront: 1, //DV-3024 Fix error consume cache

    //ERP
    replaceConflictCharacter: 1, //DV-3128 Replace ; character for : characater

    //Plasmic
    enableCDNPlasmicInProductSheet: 1, // DV-3300 Implement the Plasmic component injection solution through the CDN in the product sheets

    //BO
    editCollectionFeatures: 1, // DV-1884 Implement edit collections features tools in bo-eproducts

    // Debug
    logDomainConstructor: 0, // DEBUGG Toggle to debug domain constructor instantiation

    //Force range create userId
    forceUserIdRangeByHostName: 1,
}

// No se ha activado este set en el pro viejo, pero deberia usar este. Esta usando NONE como default por ahora.
const togglesPro = {}

const toggleSets = {
    NONE: {},
    DEV: togglesDev,
    NEWPRO: togglesNewPro,
    PRO: togglesPro
}

const getToggleSet = () => {
    const toggleSet = process.env.TOGGLESET || process.env.REACT_APP_TOGGLESET || 'NONE' // In craco, only REACT_APP_ prefixed envars reach React.
    return toggleSets[toggleSet]
}

const envValues = {
    ...getToggleSet(),
    ...TogglesLocal
}

const envKeys = Object.keys(envValues)

export default class Toggles {
    /**
     * Get the appropriate ConfigCat API key based on environment variables
     * @returns The ConfigCat API key or undefined
     */
    static getConfigCatApiKey(): string | undefined {
        return TogglesV2.getConfigCatApiKey()
    }

    /**
     * Initialize TogglesManager with runtime API key (for Next.js apps)
     * @param apiKey - ConfigCat API key from runtime config
     */
    static initialize(apiKey: string) {
        TogglesV2.initialize(apiKey)
    }

    static isEnabled(toggle) {

        const toggleInFile = envKeys.includes(toggle)
        let configCatToggle = false
        if (!toggleInFile) {
            configCatToggle = TogglesV2.isEnabled(toggle)
        }

        const value = envValues[toggle] || 0
        const random = Math.random()
        return configCatToggle || value > random || value == 1
    }

    static async isEnabledAsync(toggle: string): Promise<boolean> {
        const toggleInFile = envKeys.includes(toggle)
        if (toggleInFile) {
            const value = envValues[toggle] || 0
            const random = Math.random()
            return value > random || value == 1
        }
        return TogglesV2.isEnabledAsync(toggle)
    }

    /** Like `isEnabled`, but evaluates ConfigCat targeting rules for the given user email. */
    static isEnabledForEmail(toggle: string, email?: string): boolean {
        const toggleInFile = envKeys.includes(toggle)
        let configCatToggle = false
        if (!toggleInFile) {
            configCatToggle = TogglesV2.isEnabledForEmail(toggle, email)
        }
        const value = envValues[toggle] || 0
        const random = Math.random()
        return configCatToggle || value > random || value == 1
    }

    /** Async variant of `isEnabledForEmail` (server-side: awaits ConfigCat ready). */
    static async isEnabledForEmailAsync(toggle: string, email?: string): Promise<boolean> {
        const toggleInFile = envKeys.includes(toggle)
        if (toggleInFile) {
            const value = envValues[toggle] || 0
            const random = Math.random()
            return value > random || value == 1
        }
        return TogglesV2.isEnabledForEmailAsync(toggle, email)
    }

    /** Like `isEnabledForEmail`, but also sends custom attributes (e.g. role) for ConfigCat targeting rules. */
    static isEnabledForUser(toggle: string, user?: { email?: string; custom?: Record<string, string> }): boolean {
        const toggleInFile = envKeys.includes(toggle)
        let configCatToggle = false
        if (!toggleInFile) {
            configCatToggle = TogglesV2.isEnabledForUser(toggle, user)
        }
        const value = envValues[toggle] || 0
        const random = Math.random()
        return configCatToggle || value > random || value == 1
    }

    /** Async variant of `isEnabledForUser` (server-side: awaits ConfigCat ready). */
    static async isEnabledForUserAsync(toggle: string, user?: { email?: string; custom?: Record<string, string> }): Promise<boolean> {
        const toggleInFile = envKeys.includes(toggle)
        if (toggleInFile) {
            const value = envValues[toggle] || 0
            const random = Math.random()
            return value > random || value == 1
        }
        return TogglesV2.isEnabledForUserAsync(toggle, user)
    }

    static getValue(toggle) {
        return TogglesV2.getValue(toggle);
    }
}
